/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NursingInterventionsStartAliases {
  ACCORDION_INFORMATION = 'accordion-information',
  BUTTON_EXECUTE = 'button-execute',
  CONTENT_INFORMATION_HEADER = 'content-information-header',
  DATE_HOUR_FIELD = 'date-hour-field',
  DATE_HOUR_INPUT = 'date-hour-input',
  GLOBAL_ACTIONS_EXECUTE = 'global-actions-execute',
  INFORMATION_FORM = 'information-form',
  INFORMATION_TEXT = 'information-text',
  JUSTIFICATION_FIELD = 'justification-field',
  JUSTIFICATION_TEXT_AREA = 'justification-text-area',
  NURSING_INTERVENTIONS_START_LAYOUT = 'nursing-interventions-start-layout',
  OBSERVATION_FIELD = 'observation-field',
  OBSERVATION_TEXT_AREA = 'observation-text-area',
  PANEL_ACCORDION_INFORMATION = 'panel-accordion-information',
  PANEL_FORM_INFORMATION = 'panel-form-information',
  PANEL_INFORMATION_HEADER = 'panel-information-header',
  TEXT_NURSING_INTERVENTIONS_DATE = 'text-nursing-interventions-date',
  TEXT_NURSING_INTERVENTIONS_INFORMATION = 'text-nursing-interventions-information',
}
export { NursingInterventionsStartAliases };
